import type {FC, HTMLAttributes} from 'react'
import React from 'react'

import * as s from './tabs.styles'

export interface TabsProps extends HTMLAttributes<HTMLDivElement> {
    tall?: boolean
    scrollHorizontally?: boolean
}

/**
 * @deprecated Use '@pleo-io/telescope' Tabs
 */
export const Tabs: FC<TabsProps> = ({children, tall, ...props}) => {
    return (
        <s.Tabs data-generic-ui="tabs" {...props}>
            {React.Children.map(children, (child: any) =>
                child ? React.cloneElement(child, {tall}) : null,
            )}
        </s.Tabs>
    )
}

export const Tab: FC<s.TabProps> = ({children, to, active, testId, className, ...props}) => {
    if (to) {
        return (
            <s.TabLink to={to} end data-testid={testId} className={className} {...props}>
                {children}
            </s.TabLink>
        )
    }

    return (
        <s.TabAnchor
            data-testid={testId}
            className={`${active ? 'active' : ''} ${className ?? ''}`}
            {...props}
        >
            {children}
        </s.TabAnchor>
    )
}
